import { ComponentType, ReactElement, ReactNode } from 'react';

export const ConditionalWrapper = ({
    condition,
    Wrapper,
    children,
}: {
    condition: boolean;
    Wrapper: ComponentType<{ children: ReactNode }>;
    children: ReactElement;
}) => {
    return condition ? <Wrapper>{children}</Wrapper> : children;
};
